import { DataList, Flex, Text } from '@radix-ui/themes'
import { formatTimeAgo } from '~/utils/date'
import { formatInstant } from './format'
import { LeakV0DetailRow, LeakV0PanelBox } from './LeakV0PanelBox'
import { leakV0Warmup, summarizeLeakV0Status, type StationLeakV0Status } from './summary'

interface LeakV0FreshnessPanelProps {
  status: StationLeakV0Status
  now?: Date
}

interface InstantProps {
  at: string | null
  now: Date
  absent: string
  color?: 'gray' | 'amber'
}

const Instant = ({ at, now, absent, color = 'gray' }: InstantProps) =>
  at === null ? (
    <Text color="gray">{absent}</Text>
  ) : (
    <Flex direction="column">
      <Text>{formatInstant(at)}</Text>
      <Text size="1" color={color}>
        {formatTimeAgo(at, now)}
      </Text>
    </Flex>
  )

export const LeakV0FreshnessPanel = ({ status, now = new Date() }: LeakV0FreshnessPanelProps) => {
  // The collapsed card's own verdict, so the staleness call cannot differ between the two.
  const { color } = summarizeLeakV0Status(status, now)

  return (
    <LeakV0PanelBox title="Detector freshness">
      <DataList.Root size="1" orientation="vertical">
        <LeakV0DetailRow
          label="Last bucket"
          value={
            <Instant at={status.lastBucketAt} now={now} absent="the detector has written nothing" color={color} />
          }
        />
        <LeakV0DetailRow
          label="Last meter reading"
          value={<Instant at={status.lastReadingAt} now={now} absent="the meter has never reported" />}
        />
        <LeakV0DetailRow label="Warm-up" value={leakV0Warmup(status, now).label} />
      </DataList.Root>
      <Text size="1" color="gray">
        Abstention and dead-meter holds are not persisted and cannot be shown here.
      </Text>
    </LeakV0PanelBox>
  )
}
